import axios from 'axios'
const CancelToken = axios.CancelToken
export class Fetcher {
  constructor(options) {
    const { perPage = Infinity } = options || {}
    this._isFetching = false
    this._page = 1
    this._cancelTokenSource = null
    this._isPaginationFinished = false
    this._totalRecords = 0
    this._error = null
    this._data = []
    this._perPage = perPage
  }

  async fetch(promise) {
    if (this._cancelTokenSource) {
      this._cancelTokenSource.cancel()
    }
    this._cancelTokenSource = CancelToken.source()

    this._isFetching = true
    this._error = null

    try {
      const { totalRecords, data } = await promise({
        cancelToken: this._cancelTokenSource.token,
        page: this._perPage === Infinity ? undefined : this._page,
        perPage: this._perPage === Infinity ? undefined : this._perPage
      })

      if (this._page === 1) {
        this._data = data
      } else {
        this._data = [...this._data, ...data]
      }

      if (this._perPage !== Infinity) {
        this._totalRecords = totalRecords

        if (
          this._page * this._perPage >= this._totalRecords ||
          this._data?.length >= this._totalRecords ||
          !data?.length
        ) {
          this._isPaginationFinished = true
        }
      } else {
        this._isPaginationFinished = true
      }

      this._error = null
      this._isFetching = false

      this._page = this._page + 1
    } catch (e) {
      if (!axios.isCancel(e)) {
        this._error = e
        this._isFetching = false
      }
    }
  }

  get isFetching() {
    return this._isFetching
  }

  get data() {
    return this._data
  }

  get error() {
    return this._error
  }

  get totalRecords() {
    return this._totalRecords
  }

  get isPaginationFetching() {
    return this._page > 1 && this._isFetching
  }

  get page() {
    return this._page
  }

  set page(page) {
    this._page = page
  }

  get cancelTokenSource() {
    return this._cancelTokenSource
  }

  get isPaginationFinished() {
    return this._isPaginationFinished || this._data.length >= this.totalRecords
  }

  set isPaginationFinished(isPaginationFinished) {
    this._isPaginationFinished = isPaginationFinished
  }

  set data(data) {
    this._data = data
  }

  resetData() {
    this._data = []
  }

  reset() {
    this._isFetching = false
    this._page = 1
    this._isPaginationFinished = false
    // this._cancelTokenSource = null
  }
}
